// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__22Ii5","inner":"Footer_inner__perl_"};